import { SessionAlertType } from "@simbelapp/order-sdk";

export { SessionAlertType };

export enum AlertTab {
  ACTIVE = "active",
  ARCHIVED = "archived",
}

export const AlertTabLabel: Record<AlertTab, string> = {
  [AlertTab.ACTIVE]: "Actives",
  [AlertTab.ARCHIVED]: "Archivées",
};

export enum AlertStatus {
  ACTIVE = "active",
  ARCHIVED = "archived",
  RESOLVED = "resolved",
}

export enum AlertScope {
  GLOBAL = "global",
  SESSION = "session",
}

export enum AlertTag {
  UNAVAILABILITY = "Participants indisponibles",
  SESSION_NOT_SUMMONED = "Session non convoquée",
  ATTENDEE_NOT_SUMMONED = "Participants non convoqués",
  MINIMUM_CAPACITY_NOT_REACHED = "Capacité minimale non atteinte",
  ATTENDANCE_NOT_DECLARED = "Présences non déclarées",
}

export enum AlertTagSingular {
  UNAVAILABILITY = "Participant indisponible",
  SESSION_NOT_SUMMONED = "Session non convoquée",
  ATTENDEE_NOT_SUMMONED = "Participant non convoqué",
  MINIMUM_CAPACITY_NOT_REACHED = "Capacité minimale non atteinte",
  ATTENDANCE_NOT_DECLARED = "Présence non déclarée",
}
